import Head from "next/head"
import MainLayout from "../../../layouts/mainLayout"
import { getIsSsrMobile } from "src/utils/getIsSsrMobile"
import Content from "src/components/pages/jet-card/Content";

const JetCardPage = () => {
  return (
    <>
      <Head>
        <title>جت کارت</title>
      </Head>
      <Content />
    </>
  )
}

JetCardPage.Layout = MainLayout

export default JetCardPage

export async function getServerSideProps(context) {
  return {
    props: {
      isSsrMobile: getIsSsrMobile(context)
    }
  }
}
